export function removeLastWord(fullName: string | null | undefined): string {
  if (!fullName) return '';

  const parts = fullName.trim().split(/\s+/);
  if (parts.length <= 1) {
    return fullName.trim();
  }

  return parts.slice(0, -1).join(' ');
}
